<template>
  <div>
    <page-header
      left-side-class="col-12 col-md-7"
      :page="headerConfig"
      right-side-class="col-12 col-md-5"
      class="mt-3 mt-md-0"
      @onReturn="() => $router.back()"
      :has-return="true"
    />

    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="process"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "PageHeader";
import FilterManager from "FilterManager";
import Thrpy from "@/services/api/thrpy.api";
import ReportServices from '@/modules/report/api';
import DocumentServices from '@//modules/report/document'

export default {
  name: "TapDisburstmentRequestStudentEligibilityApprovedVue",
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => ({    
    model: {
     search: {
       collections: {
         academicYears: [],         
         disburstmentTypes: []
       },
       filters: {
         academicYear: null,
         disburstmentType: null            
       },
     }
    }
  }),
  computed: {
    headerConfig() {
      return {
        title: 'Informe Mensual Lista de Estudiantes Aprobados Reembolso y Pago Directo',
        icon:
          'fas fa-chart-pie',
        routes: ['Informes', 'Informe Mensual Lista de Estudiantes Aprobados Reembolso y Pago Directo'],
      }
    },
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Año Académico:',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un año académico.',
          validations: 'required',
          class: 'col-md-3',
          clearable: false,
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYear,                  
        },
        {
          name: 'disburstmentType',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Mecanismo de Pago:',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un mecanismo de pago.',
          validations: 'required',
          class: 'col-12 col-md-3',
          clearable: false,
          options: this.model.search.collections.disburstmentTypes,
          value: this.model.search.filters.disburstmentType,          
        }        
      ]   
    }
  },
  async mounted() {
    const { data } = await Thrpy.getTapDisbursementRequestStudentEligibilityApproved();
    this.model.search.collections.academicYears = data.academicYearList;
    this.model.search.collections.disburstmentTypes = data.disburstmentTypeList;
    this.model.search.filters.academicYear = null;
    this.model.search.filters.disburstmentTypes = null;    
  },
  methods: {
    async process() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate();

      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );
        return;
      }
      await ReportServices.getReport('tapdisburstmentrequeststudenteligibilityapproved', {
        academicYearId: this.model.search.filters.academicYear?.id,
        disburstmentType: this.model.search.filters.disburstmentType?.id,
        academicYearDescription: this.model.search.filters.academicYear?.name
      }).then((res) => DocumentServices.Download(res.data));
    },
  },
}
</script>